// Use light version to minimize dependency size. Only supports SVG.
import lottie from 'lottie-web/build/player/lottie_light';
import type {AnimationItem} from 'lottie-web';
import {AttrsSchema, Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

export type LottiePlayerConfig = {path: string};

export interface LottiePlayerJsxProps {
  attrs: {
    config: LottiePlayerConfig;
  };
}
export class LottiePlayer extends Component<EmptyObj, LottiePlayerJsxProps['attrs']> {
  private animation: AnimationItem;
  private containerEl: HTMLDivElement;

  static get attrsSchema(): AttrsSchema<LottiePlayerJsxProps['attrs']> {
    return {
      config: {type: `json`, tsType: `LottiePlayerConfig`},
    };
  }

  get config() {
    return {
      template(this: LottiePlayer) {
        return (
          <div sel='.lottie-wrapper'>
            <div sel='.lottie-container' hook={{insert: (vnode) => this.onContainerInserted(vnode)}} />
          </div>
        );
      },
    };
  }

  disconnectedCallback() {
    this.animation?.destroy();
    super.disconnectedCallback();
  }

  onContainerInserted(vnode) {
    this.containerEl = vnode.elm;
    this.loadAnimation();
  }

  loadAnimation() {
    this.animation = lottie.loadAnimation({
      loop: true,
      autoplay: true,
      ...this.attr(`config`),
      container: this.containerEl,
      renderer: `svg`,
    });
  }
}

export const LottieEl = defineAndMakeJsxFactory<LottiePlayerJsxProps>(`mp-lottie-player`, LottiePlayer);
export const LottieReact = panel2react<LottiePlayerJsxProps>(`mp-lottie-player`, LottiePlayer);
